import SmartTraderIFrame from './SmartTraderIFrame.jsx';

export default SmartTraderIFrame;
